module.exports = __webpack_public_path__ + "img/apple-icon.ab6c89b.png";